<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-green fixed-top w-100">
    <router-link class="navbar-brand me-lg-15 custom-padding-left" to="/">
      <img src="/media/logos/logo.svg" alt="logo" class="d-inline-block align-text-top custom-logo" />
    </router-link>

    <button class="navbar-toggler border-0" type="button" data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
      aria-label="Toggle navigation" @click="toggleShowNav">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div :class="{ collapse: showNav == false }"
      class=" navbar-collapse justify-content-lg-between menu-title-gray-800 menu-state-title-tertiary"
      id="#kt_header_menu" data-kt-menu="true">
      <ul class="navbar-nav d-flex align-items-center">
        <div class="menu-item">
          <router-link class="menu-link" active-class="active" to="/">
            Laman Utama
          </router-link>
        </div>
        <!-- <div class="menu-item">
          <router-link class="menu-link" active-class="active" v-if="isAuthenticated"
            :to="{ name: 'status-kenaikan-pangkat' }">
            Status
          </router-link>
        </div> -->
        <li class="menu-item" v-if="isPsm == false" >
          <router-link class="menu-link" active-class="active" :to="{ name: 'kenaikan-pangkat' }">
            Perkhidmatan
          </router-link>
        </li>
        <div class="menu-item" v-if="isPsm == false" >
          <router-link class="menu-link" active-class="active" :to="{ name: 'info-peperiksaan' }">
            Peperiksaan
          </router-link>
        </div>
        <div class="menu-item" v-if="isPsm == false" >
          <router-link class="menu-link" active-class="active" :to="{ name: 'pergerakan-pegawai' }">
            Pergerakan Pegawai
          </router-link>
        </div>
        <div class="menu-item">
          <!-- <span -->
          <router-link class="cursor-pointer menu-link" active-class="active" :to="{ name: 'help-page' }">
            Panduan Pengguna
            <!-- </span
            > -->
            <!-- <router-link
              class="menu-link"
              active-class="active"
              :to="{ name: 'help-page' }"
            > -->
            <!-- @click="getUserManual()" -->
          </router-link>
        </div>
      </ul>
      <ul v-if="isAuthenticated" class="navbar-nav d-flex align-items-center">
        <li class="nav-item">
          <!-- <button class="btn btn-default">
              <span class="svg-icon svg-icon-1">
                <img src="/media/icons/duotune/general/gen007.svg"
              /></span>
            </button> -->
        </li>
        <li class="nav-item">
          <!--begin::Avatar-->
          <!--            <div class="avatar">{{ initial }}</div>-->
          <!--end::Avatar-->
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarScrollingDropdown" role="button"
            data-bs-toggle="dropdown" aria-expanded="false">
            {{ username }}
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarScrollingDropdown" :class="[hasSubmenu == true ? 'translate-menu' : '']" >
            <li class="dropdown-submenu">
              <a>
                <button class="dropdown-item" @click="toDashboard" role="link">
                  Dashboard
                </button>
              </a>
              <ul class="submenu">
                <li>
                  <router-link to="/dashboard" class="dropdown-item" >Dashboard Pengguna</router-link>
                </li>
                <li>
                  <router-link v-if="showDashboardPentadbiran" class="dropdown-item" to="/pentadbiran/dashboard">Dashboard Pentadbir</router-link>
                </li>
                <li>
                  <router-link v-if="showDashboardPerkhidmatan" class="dropdown-item" to="/perkhidmatan/dashboard">Dashboard Perkhidmatan</router-link>
                </li>
                <li>
                  <router-link v-if="showDashboardPsm" class="dropdown-item" to="/psm/dashboard">Dashboard PSM</router-link>
                </li>
                <li>
                  <router-link  v-if="showDashboardPeperiksaan" class="dropdown-item" to="/peperiksaan/dashboard">Dashboard Peperiksaan</router-link>
                </li>
              </ul>
            </li>
            <li>
              <router-link :to="{ name: 'pengguna-profile' }" custom v-slot="{ navigate }">
                <button class="dropdown-item" @click="navigate" @keypress.enter="navigate" role="link">
                  Profil
                </button>
              </router-link>
            </li>
            <li>
              <button @click="logout" class="dropdown-item">Log Keluar</button>
            </li>
          </ul>
        </li>
      </ul>
      <ul class="navbar-nav d-flex align-items-center" v-if="isAuthenticated == false && isPsm == false" >
        <li class="menu-item">
          <router-link :to="{ name: 'verify-nric' }" custom v-slot="{ navigate }">
            <button type="button" class="btn btn-default menu-link nav-button" role="link" @click="navigate"
              @keypress.enter="navigate">
              Daftar
            </button>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="btn btn-primary" :to="{ name: 'sign-in' }">
            Log Masuk
          </router-link>
        </li>
      </ul>
    </div>
  </nav>

  <div class="container below-container">
    <!-- Your existing content here -->
  </div>
</template>

<script >
import { defineComponent, onMounted, computed, reactive, watch, ref } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { useRouter, useRoute } from "vue-router";
import Cookies from "js-cookie";
import Masthead from "@/components/custom/layout/Masthead.vue";
import { LaporanMenuItems, PeperiksaanMenuItems, PerkhidmatanMenuItems, PsmMenuItems, SistemMenuItems } from "@/layout/aside/tabs/MenuItems";

export default defineComponent({
  name: "custom-navbar",
  components: {},
  methods: {
    toDashboard() {
      const currentUser = this.store.getters.currentUser;
      const listHadCapaian = this.store.getters.hadCapaian;
      console.log({ currentUser, listHadCapaian });

      const hadCapaianPerkhidmatan = listHadCapaian.filter((item) => item.modul_name == 'perkhidmatan');
      if (hadCapaianPerkhidmatan.length > 0) {
        if (hadCapaianPerkhidmatan.some((item) => item.menu_name == 'perkhidmatan_dashboard') == true) {
          this.router.push('/perkhidmatan/dashboard');
          return;
        } else {
          const p1 = hadCapaianPerkhidmatan[0];
          const p2 = PerkhidmatanMenuItems.filter((item) => item.ctrl == p1.menu_name);
          if (p2.length > 0) {
            this.router.push(p2[0].link);
            return;
          }
        }  
      }

      const hadCapaianPsm = listHadCapaian.filter((item) => item.modul_name == 'psm');
      if (hadCapaianPsm.length > 0) {
        if (hadCapaianPsm.some((item) => item.menu_name == 'psm_dashboard') == true) {
          this.router.push('/psm/dashboard');
          return;
        } else {
          const p1 = hadCapaianPsm[0];
          const p2 = PsmMenuItems.filter((item) => item.ctrl == p1.menu_name);
          if (p2.length > 0) {
            this.router.push(p2[0].link);
            return;
          }
        }
      }

      const hadCapaianPeperiksaan = listHadCapaian.filter((item) => item.modul_name == 'peperiksaan');
      console.log({hadCapaianPeperiksaan});
      if (hadCapaianPeperiksaan.length > 0) {
        if (hadCapaianPeperiksaan.some((item) => item.menu_name == 'peperiksaan_dashboard') == true) {
          this.router.push('/peperiksaan/dashboard');
          return;
        } else {
          const p1 = hadCapaianPeperiksaan[0];
          const p2 = PeperiksaanMenuItems.filter((item) => item.ctrl == p1.menu_name);
          console.log({p1,p2});
          if (p2.length > 0) {
            this.router.push(p2[0].link);
            return;
          }
        }
      }

      const hadCapaianAdmin = listHadCapaian.filter((item) => item.modul_name == 'Pentadbir Sistem');
      if (hadCapaianAdmin.length > 0) {
        if (hadCapaianAdmin.some((item) => item.menu_name == 'sistem_dashboard') == true) {
          this.router.push('/pentadbiran/dashboard');
          return;
        } else {
          const p1 = hadCapaianAdmin[0];
          const p2 = SistemMenuItems.filter((item) => item.ctrl == p1.menu_name);
          if (p2.length > 0) {
            // this.router.push(p2[0].link);
            this.router.push(p2[0].route);
            return;
          }
        }
      }

      const hadCapaianLaporan = listHadCapaian.filter((item) => item.modul_name == 'laporan');
      console.log({hadCapaianLaporan});
      if (hadCapaianLaporan.length > 0) {
        const p1 = hadCapaianLaporan[0];
        const p2 = LaporanMenuItems[0].pages.filter((item) => item.name == p1.menu_name);
        console.log({p2,p1, LaporanMenuItems});
        if (p2.length > 0) {
          this.router.push(p2[0].route);
          return;
        }
      }
      
      this.router.push('/dashboard');
    },
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    watch(route, (to, from) => {
      if (showNav.value == true) {
        showNav.value = false;
        // console.log('NavBar :: route changed :: from', from);
        // console.log('NavBar :: route changed :: to', to);
        console.log('NavBar :: route changed :: hide navbar');

      }
    });

    const user = reactive({
      name: "Guest",
    });

    const username = computed(() => {
      return (
        store.getters.currentUser.name || Cookies.get("user_name") || "Guest"
      );
    });

    const logout = () => {
      store
        .dispatch(Actions.LOGOUT)
        .then(() => router.push({ name: "sign-in" }));
    };

    // const getUserManual = () => {
    //   const url = "/files/ManualPenggunaAwam.pdf";
    //   window.open(url, "_blank");
    // };
    const showNav = ref(false);
    const toggleShowNav = () => {
      showNav.value = !showNav.value;
    };

    return {
      showNav,
      toggleShowNav,
      logout,
      user,
      // getUserManual,
      username,
      store,
      router,
      route,
    };
  },
  computed: {
    hasSubmenu(){
      return this.showDashboardPentadbiran || this.showDashboardPeperiksaan || this.showDashboardPerkhidmatan || this.showDashboardPsm;
    },
    showDashboardPsm(){
      let {list_fungsi_kerja} = this.store.getters.currentUser;
      list_fungsi_kerja = list_fungsi_kerja || [];
      const list_nama_fungsi_kerja = list_fungsi_kerja.map((item) => item.nama.toLowerCase());
      if(list_nama_fungsi_kerja.indexOf('pentadbir psm') >= 0) {
        return true;
      }

      const listHadCapaian = this.store.getters.hadCapaian;

      const hadCapaianPsm = listHadCapaian.filter((item) => item.modul_name == 'psm');
      if (hadCapaianPsm.length > 0) {
        if (hadCapaianPsm.some((item) => item.menu_name == 'psm_dashboard') == true) {
          return true;
        } else {
          const p1 = hadCapaianPsm[0];
          const p2 = PsmMenuItems.filter((item) => item.ctrl == p1.menu_name);
          if (p2.length > 0) {
            return true;
          }
        }
      }
      return false;
    },
    showDashboardPeperiksaan(){
      let {list_fungsi_kerja} = this.store.getters.currentUser;
      list_fungsi_kerja = list_fungsi_kerja || [];
      const list_nama_fungsi_kerja = list_fungsi_kerja.map((item) => item.nama.toLowerCase());
      if(list_nama_fungsi_kerja.indexOf('pentadbir peperiksaan') >= 0) {
        return true;
      }

      const listHadCapaian = this.store.getters.hadCapaian;

      const hadCapaianPeperiksaan = listHadCapaian.filter((item) => item.modul_name == 'peperiksaan');
      console.log({hadCapaianPeperiksaan});
      if (hadCapaianPeperiksaan.length > 0) {
        if (hadCapaianPeperiksaan.some((item) => item.menu_name == 'peperiksaan_dashboard') == true) {
          return true;
        } else {
          const p1 = hadCapaianPeperiksaan[0];
          const p2 = PeperiksaanMenuItems.filter((item) => item.ctrl == p1.menu_name);
          console.log({p1,p2});
          if (p2.length > 0) {
            return true;
          }
        }
      }
      return false;
    },
    showDashboardPentadbiran(){
      let {list_fungsi_kerja} = this.store.getters.currentUser;
      list_fungsi_kerja = list_fungsi_kerja || [];
      const list_nama_fungsi_kerja = list_fungsi_kerja.map((item) => item.nama.toLowerCase());
      if(list_nama_fungsi_kerja.indexOf('pentadbir sistem') >= 0) {
        return true;
      }

      const listHadCapaian = this.store.getters.hadCapaian;

      const hadCapaianAdmin = listHadCapaian.filter((item) => item.modul_name == 'Pentadbir Sistem');
      if (hadCapaianAdmin.length > 0) {
        if (hadCapaianAdmin.some((item) => item.menu_name == 'sistem_dashboard') == true) {
          return true;
        } else {
          const p1 = hadCapaianAdmin[0];
          const p2 = SistemMenuItems.filter((item) => item.ctrl == p1.menu_name);
          if (p2.length > 0) {
            return true;
          }
        }
      }
      return false;
    },
    showDashboardPerkhidmatan(){
      const validFungsiKerja = [
        'skim penolong dan pembantu akauntan',
        'skim gunasama',
        'pergerakan',
        'perjawatan',
        'skim akauntan',
      ];
      let {list_fungsi_kerja} = this.store.getters.currentUser;
      list_fungsi_kerja = list_fungsi_kerja || [];
      const list_nama_fungsi_kerja = list_fungsi_kerja.map((item) => item.nama.toLowerCase());

      const _isValidFungsiKerja = (nama_fungsi_kerja) => {
        return validFungsiKerja.indexOf(nama_fungsi_kerja) >= 0;
      };

      if(list_nama_fungsi_kerja.some((nama_fungsi_kerja) => _isValidFungsiKerja(nama_fungsi_kerja)) == true) {
        return true;
      }


      const listHadCapaian = this.store.getters.hadCapaian;

      const hadCapaianPerkhidmatan = listHadCapaian.filter((item) => item.modul_name == 'perkhidmatan');
      if (hadCapaianPerkhidmatan.length > 0) {
        if (hadCapaianPerkhidmatan.some((item) => item.menu_name == 'perkhidmatan_dashboard') == true) {
          return true;
        } else {
          const p1 = hadCapaianPerkhidmatan[0];
          const p2 = PerkhidmatanMenuItems.filter((item) => item.ctrl == p1.menu_name);
          if (p2.length > 0) {
            return true;
          }
        }  
      }
      return false;
    },
    initial() {
      // const str = this.user.name ? this.user.name : "Guest";
      const str = this.username || 'Guest';

      var firstLetters = str.match(/\b(\w)/g);
      if (firstLetters.length > 2) {
        firstLetters = firstLetters.slice(0, 2);
      }
      const initial = firstLetters.join("").toUpperCase();

      return initial;
    },
    isAuthenticated() {
      const store = useStore();
      return store.getters.isUserAuthenticated;
    },
    isPsm(){
      console.log('navbar :: isPsm', this.route.path);
      const escapedPath = [
        '/psm/login',
        '/psm/password-reset',
      ];
      if(escapedPath.indexOf(this.route.path) >= 0) {
        return true;
      }
      return false;
    }
  },
});
</script>

<style scoped>
.bg-green {
  background-color: #04c8c8 !important;
}

.menu-link,
.navbar-nav .nav-link {
  color: #000 !important;
  font-weight: bold;
}

.nav-button {
  font-size: inherit;
  font-weight: inherit;
}

.navbar {
  margin-bottom: 0 !important;
}

.below-container {
  margin-top: -20px;
  padding-top: 0;
}

.custom-padding-left {
  padding-left: 15px;
  /* Adjust the value as needed */
}

.submenu {
  display: none;
  position: absolute;
  top: 0;
  left: 100%; /* Tampilkan submenu di sebelah kanan */
  margin-left: 0;
  background-color: #ffffff;
  list-style: none;
  padding: 0;
  border: 1px solid #ccc;
  z-index: 1000;
}

.dropdown-submenu:hover .submenu {
  display: block; /* Tampilkan submenu ketika disorot */
}

.translate-menu{
  transform: translate(-180px, 0px);
}

</style>
